export default "__VITE_ASSET__2F4C4TWG__"